import { memo, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { io } from "socket.io-client";
import {
  GetBgColor,
  getQrUrl,
  MarketplaceFavicon,
  MarketplaceName,
  OnelinkUrl,
} from "../../common";
import { LocalizationProvider } from "../context/LocalizationContext";
import { ConfirmButton } from "./ConfirmButton";
import { DesktopContent } from "./DesktopContent";
import { InfoBlock } from "./InfoBlock";
import styles from "./main-page.module.css";
import { MobileContent } from "./MobileContent";
import { NoAppContent } from "./NoAppContent";
import { appendMarketingParamsToUrl } from "../../affiliate-config";

interface InlineStyle {
  app: {
    background: string;
  };
  qr: {
    bgColor: string;
    fgColor: string;
  };
  qrTitle: {
    display?: string;
  };
  mobileLinkButton: {
    border?: string;
    color?: string;
  };
}

export type PageContenProps = {
  currentURL: string;
  inlineStyle: InlineStyle;
};

export type PagesProps = {
  isMobilePlatform: boolean;
};

// FYI: LEGACY FRUMZI FRONT
const inlineStyleFrumzi: InlineStyle = {
  app: {
    background: GetBgColor(),
  },
  qr: {
    bgColor: GetBgColor(),
    fgColor: "#1C2369",
  },
  qrTitle: {},
  mobileLinkButton: {},
};

const InlineStyleCustom = (color: string | null | undefined): InlineStyle => {
  return {
    app: {
      background: "transparent",
    },
    qr: {
      bgColor: "transparent",
      fgColor: color || "white",
    },
    qrTitle: {
      display: "none",
    },
    mobileLinkButton: {
      border: color ? `1px solid ${color}` : "1px solid white",
      color: color || "white",
    },
  };
};

export const MainPage = memo((props: PagesProps) => {
  const { isMobilePlatform } = props;
  const currentURL = getQrUrl();
  const [searchParams] = useSearchParams();
  const [transactionId, setTransactionId] = useState<string>("");
  const [isWebConfirmationActive] = useState<boolean>(false);

  const noApp = searchParams.get("noapp") === "true";

  // const isCustomStyles = !!searchParams.get("theme");
  const isCustomStyles = false;
  const themeColor = searchParams.get("theme");

  const inlineStyle: InlineStyle = isCustomStyles
    ? InlineStyleCustom(themeColor)
    : inlineStyleFrumzi;

  useEffect(() => {
    return void (async function () {
      const envResponse = await fetch("/env");
      const { apiURL } = await envResponse.json();
      const socketUrl = apiURL;
      const socket = io(socketUrl!);
      const transaction_id = searchParams.get("transaction_id");

      setTransactionId(transaction_id!);

      document.title = MarketplaceName() + " Qr-code page";
      var linkElement: any = document.querySelector("link[rel='icon']");
      linkElement.href = MarketplaceFavicon();

      socket.emit("transaction:subscribe", {
        transactionId: transaction_id,
      });

      socket.on(
        "transaction:status",
        (data: { status: string; redirectUrl: string; error: string }) => {
          if (data.error === "EMAIL_ALREADY_IN_USE") {
            console.log("do nothing on EMAIL_ALREADY_IN_USE now");
            return;
          }
        },
      );

      /// when user opens brand login popup in browser (funid-auth QR) and clicks at "Download app" btn, it redirects at this page (funid-payment) and if it is login or register (identify=true) - redirects to appsflyer onelink immediately
      if (
        window.location.href.includes("identify=true") ||
        searchParams.get("identify=true")
      ) {
        window.location.href = appendMarketingParamsToUrl(
          OnelinkUrl() +
            "/?transaction_id=" +
            transaction_id +
            "&identify=true",
        );
      }
    })();
  }, [searchParams]);

  return (
    <LocalizationProvider>
      <div className={styles.app} style={inlineStyle.app}>
        {isMobilePlatform ? (
          noApp ? (
            <NoAppContent />
          ) : (
            <MobileContent currentURL={currentURL} inlineStyle={inlineStyle} />
          )
        ) : (
          <DesktopContent currentURL={currentURL} inlineStyle={inlineStyle} />
        )}

        {isWebConfirmationActive ? (
          <ConfirmButton transactionId={transactionId} />
        ) : null}

        <InfoBlock />
      </div>
    </LocalizationProvider>
  );
});
